import Imgix from './Imgix';

export default class DropAHint {
    constructor() {
        this.imgixInstance = new Imgix(); // register new Imgix instance

        this.buttons = document.querySelectorAll('[data-module="share-intent"]');
        this.init();
    }


    init() { 
        this.buttons.forEach(button => {

            const target = document.querySelector('#dropahint')
            // const opts = this.parseOptions(button.getAttribute('data-module-options'));
            // const targetSelector = typeof opts.target === 'string' && opts.target.trim()
            //     ? opts.target.trim()
            //     : '#dropahint';
            //
            // // Prefer selector from options; if it doesn't resolve, still try the sibling
            // const target =
            //     document.querySelector(targetSelector) ||
            //     button.nextElementSibling;

            if (target) {// && target.dataset.target === 'share-intent') {
                button.addEventListener('click', e => this.openDialog(e, target));

                button.addEventListener('click', (e) => this.openDialog(e, target));

                const closeButton = target.querySelector('.drop-a-hint__close');
                const copyButton = target.querySelector('.drop-a-hint__link--copy');
                const overlay = target;

                if (closeButton) {
                    closeButton.addEventListener('click', () => this.closeDialog(target));
                }

                if (overlay) {
                    overlay.addEventListener('click', (e) => {
                        if (e.target === overlay) this.closeDialog(target);
                    });
                }

                if (copyButton) {
                    copyButton.addEventListener('click', () => this.copyLink(copyButton));
                }
            }
        });
    }

    // Safely parse a JSON-ish data attribute, returning {} on failure
    parseOptions(str) {
        if (!str) return {};
        try {
            // dataset/getAttribute will have already unescaped &quot; -> "
            return JSON.parse(str);
        } catch {
            // last-resort: try to coerce single quotes -> double quotes
            try {
                return JSON.parse(str.replace(/'/g, '"'));
            } catch {
                return {};
            }
        }
    }

    openDialog(e, target) {
        e.preventDefault();
        document.body.classList.add('dropping-a-hint');

        if (typeof target.showModal === 'function') {
                target.showModal();
            } else {
            // Fallback if not a <dialog>
            target.classList.add('is-open');
        }

        this.imgixInstance.process(target);
    }

    closeDialog(target) {
        document.body.classList.remove('dropping-a-hint');
        if (typeof target.close === 'function') {
            target.close();
            } else {
                target.classList.remove('is-open');
            }
        }

            copyLink(button) {
                navigator.clipboard.writeText(window.location.href).then(() => {
            button.classList.add('copied');
            setTimeout(() => button.classList.remove('copied'), 1000);
        });
    }
}
